import {FC, useEffect, useState} from "react";
import Multiselect from "multiselect-react-dropdown";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {EditorState} from "draft-js";
import {Editor} from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

interface DependenciesProps {
  dependency: externalDependencies[];
  setDependency: (dependencies: externalDependencies[]) => void;
  preview?: boolean;
}

interface externalDependencies {
  description: EditorState;
  type: string;
}

const Dependencies: FC<DependenciesProps> = ({dependency, setDependency, preview}) => {
  const [selectedValue, setSelectedValue] = useState([]);
  const options = [
    {name: "Postgres"},
    {name: "MySQL"},
    {name: "Oracle"},
    {name: "REDIS"},
    {name: "KAFKA"},
    {name: "RabbitMQ"},
  ];
  
  useEffect(() => {
    if (dependency) {
      const newSelectedValue = dependency.map((dep) => ({name: dep.type} as never));
      setSelectedValue(newSelectedValue);
    }
  }, [dependency]);
  
  const onSelect = (selectedList: any, _selectedItem: any) => {
    setSelectedValue(selectedList);
  };
  
  const onRemove = (selectedList: any, _removedItem: any) => {
    setSelectedValue(selectedList);
  };
  
  const onDependencyEditorStateChange = (editorState: any, depend: string) => {
    if (dependency && dependency.find((dep) => dep.type === depend))
      setDependency(
        dependency.map((dep) =>
          dep.type === depend ? {...dep, description: editorState} : dep
        )
      );
    else
      setDependency([
        ...(dependency ?? []),
        {description: editorState, type: depend},
      ]);
  };
  
  return (
    <div className="flex flex-col justify-stretch gap-3 w-full mx-auto min-w-[200px] bg-shred rounded-3xl relative p-6">
      <h2 className="text-xl text-white mb-3 col-span-12">Dependencies</h2>
      <Multiselect
        className="grow"
        placeholder="Select delpendecies"
        options={options}
        selectedValues={selectedValue}
        onSelect={onSelect}
        onRemove={onRemove}
        displayValue="name"
        disable={preview}
      />
      {selectedValue.length > 0 && (
        <>
          <h2 className="text-lg text-white mb-3 col-span-12">Dependencies</h2>
          <Accordion type="single" collapsible className="w-full">
            {selectedValue.map((value: any, index: number) => (
              <AccordionItem value={"item-" + index} key={index}>
                <AccordionTrigger className="text-[#6F6AF8] inputoutput font-bold tracking-wide">
                  {value.name}
                </AccordionTrigger>
                <AccordionContent>
                  {preview && dependency.length > 0 ? (
                    <>
                      {dependency.map((dep) => {
                        if (dep.type === value.name) {
                          return (
                            <div
                              className="bg-white p-3 rounded-2xl text-black"
                              dangerouslySetInnerHTML={{
                                __html: dep.description,
                              }}
                            ></div>
                          );
                        }
                      })}
                    </>
                  ) : (
                    <Editor
                      placeholder="Write your description here"
                      editorStyle={{
                        maxHeight: "500px",
                        minHeight: "100px",
                        border: "1px solid #E4E4E7",
                        paddingLeft: "5px",
                        backgroundColor: "white",
                      }}
                      editorState={
                        dependency?.find((dep) => dep.type === value.name)
                          ?.description
                      }
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      onEditorStateChange={(editorState) =>
                        onDependencyEditorStateChange(editorState, value.name)
                      }
                    />
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </>
      )}
    </div>
  );
};

export default Dependencies;